import type { EmailServiceSubmitFormRequest } from 'apiConnector/email-service';
import type { EmailServiceRecipient } from 'models/emailService/EmailServiceRecipient';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { getBlotterPanelItemId } from 'state/blotters/blotterPanel/blotterPanel.selector';
import type { Thunk } from 'state/state.common';

import { emailServiceFormSubmissionRequested } from './emailService.actions';
import {
  getEmailServiceEmailDocuments,
  getEmailServiceEmailRecipient,
  getEmailServiceEmailSubject,
  isEmailServiceFormValid,
} from './emailService.selectors';

// TODO: Unit test
export function emailServiceFormSubmissionRequestedThunk(): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();

    const isFormValid = isEmailServiceFormValid(state);
    if (!isFormValid) {
      return;
    }

    const tradeId = getBlotterPanelItemId(state);
    if (!tradeId) {
      return;
    }

    const subject = getEmailServiceEmailSubject(state);
    const recipient = getEmailServiceEmailRecipient(state);
    const documents = getEmailServiceEmailDocuments(state);

    const request: EmailServiceSubmitFormRequest = { subject, recipient, documents };

    dispatch(emailServiceFormSubmissionRequested(tradeId, request));
    logAnalyticsSendEmail(request.recipient);
  };
}

function logAnalyticsSendEmail(recipient: EmailServiceRecipient) {
  switch (recipient) {
    case 'Client':
      logAnalytics.trackEvent('Email service', 'Send email', 'Send to client');
      break;
    case 'Me':
      logAnalytics.trackEvent('Email service', 'Send email', 'Forward to me');
      break;
    default:
      break;
  }
}
